import React from 'react';
import {wdiCore} from '@/components/WdiControls';
import { Input, Popover} from 'antd';
import {ProjectSelectProps} from "@/pages/sales/sa/components/SaSelectApp";
import {getSaLink} from "@/pages/sales/sa/components/data";



export const SaViewApp: React.FC<ProjectSelectProps> = (props) => {

  return (
    <>
      <Popover content={<>
        {props.value?.map(item => {
          return <a style={{display: 'block'}} onClick={() => {
            window.open(`${getSaLink(item)}?formId=${item.formSaId}&formTypeId=${item.formTypeId}&pageTypeId=${item.pageTypeId}`);
          }}>{wdiCore.String.CodeOrName(item.formNo, item.activityName)}</a>
        })}
      </>}>
        <Input readOnly
               value={props.value?.map(item => wdiCore.String.CodeOrName(item.formNo, item.activityName)).join()}
        />
      </Popover>
    </>
  );
}
